import ApiService from '../apiservice'

export default class ReportsService extends ApiService {
    constructor() {
        super('');
    }

    getLogins() {
        return this.get('/reports/login');
    }

    getCommands(filter) {
        return this.get('/cmd/history', filter);
    }

    getEvents(pageSize, pageIndex, startDate, endDate, plate) {

        return this.get('/reports/events', {
            "pageSize": pageSize,
            "pageIndex": pageIndex,
            "startDate": startDate,
            "endDate": endDate,
            "plate": plate

        });
    }

    getPositions(startDate, endDate, plate, pageSize, pageIndex) {

        return this.get('/reports/positions', {
            "startDate": startDate,
            "endDate": endDate,
            "plate": plate,
            "pageSize": pageSize,
            "pageIndex": pageIndex
        });
    }
}